import './SavedPaypalForm.css';
import React, { forwardRef, useEffect, useRef, useImperativeHandle } from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { getTaxByZip } from 'State/Checkout';
import { useForm } from 'Hooks/useForm';

export const SavedPaypalPaymentForm = forwardRef(
  ({ onFormSubmit, formName = 'savedPaypalPaymentForm', paymentMethod, selectedPlan }, ref) => {
    const { billingAddress } = paymentMethod;
    const savedPaypal = useRef();

    const formSubmitRef = {
      submitForm: () => {
        savedPaypal.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      },
    };

    const { formError, handleSubmit } = useForm({
      onFormSubmit,
      formName,
      alwaysAllowSubmit: true,
    });

    useEffect(() => {
      if (billingAddress.zipCode) {
        getTaxByZip(billingAddress.zipCode);
      }
    }, [billingAddress, selectedPlan.planId]);

    useImperativeHandle(ref, () => formSubmitRef);

    return (
      <form
        ref={savedPaypal}
        className="savedPaypalPaymentForm"
        onSubmit={(event) => handleSubmit(event)}
        name={formName}
      >
        <div className="paypalAccount">
          <img
            className="paypalAccountLogo"
            src="/account/static/images/cards/paypal-logo-01.svg"
            width="107"
            height="25"
            alt="PayPal Checkout"
          />
          <div className="paypalAccountInfo" data-dd-privacy="mask" data-heap-redact-text>
            <div>PayPal Account</div>
            <div>{paymentMethod.email}</div>
          </div>
        </div>
        <hr className="sectionLine bottom" />
        <SubmitError error={formError} formName={formName} />
      </form>
    );
  }
);
